"use strict";

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.tile-nav .a1').forEach((navItem) => {
    let navImage = navItem.parentElement.querySelector('div img').getAttribute('src');
    navItem.setAttribute('style', 'background-image: url(' + navImage + ')');
  });
});